import React from "react";
import { Form } from "react-bootstrap";

import { GEM_LANGUAGE_OPTIONS } from "../../constants/gemLanguages";

export default function GemLanguageSelect({ value, onChange, size = "sm", className }) {
  return (
    <Form.Select
      size={size}
      className={className}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      aria-label="Gem catalog language"
    >
      {GEM_LANGUAGE_OPTIONS.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </Form.Select>
  );
}
